let seatLog = [];
let seatReport = [];

export const getLog = async (start_date, end_date, office = "") => {
  const getSeatLog = async () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const params = {
      method: "POST",
      body: JSON.stringify({ office, start_date, end_date, timezone }),
    };
    const res = await fetch(process.env.REACT_APP_DB_URL + "/seat_log", params);
    const data = await res.json();
    console.log("data: ", data);
    return data;
  };

  start_date = start_date.toLocaleDateString("ja-JP").replaceAll("/", "-");
  end_date = end_date.toLocaleDateString("ja-JP").replaceAll("/", "-");

  console.log(start_date, end_date, office);

  seatLog = await getSeatLog();

  for (const log of seatLog) {
    // return from db: string 2022-08-23T18:29:28
    // UTC date string:       2022-08-23T18:29:28Z
    let date = new Date(log.timestamp + "Z").toLocaleString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    log.timestamp = date.replaceAll("/", "-");
  }

  return seatLog;
};

export const getSeatReport = async (start_date, end_date, office) => {
  const getSeatLog = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_DB_URL}/get_actual/${office}/${start_date}/${end_date}`
    );
    const data = await res.json();
    console.log("data: ", data);
    return data;
  };

  if (office === "") return [];

  start_date = start_date
    .toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replaceAll("/", "-");
  end_date = end_date
    .toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replaceAll("/", "-");

  console.log(start_date, end_date, office);

  seatReport = await getSeatLog();

  return seatReport;
};
